import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export interface Product {
  id: string;
  name: string;
  [key: string]: unknown;
}

export interface ProductState {
  productList: Product[];
  productDetail?: Product;
}

export const initialProductState: ProductState = {
  productList: [],
  productDetail: undefined,
};

export const productSlice = createSlice({
  name: "product",
  initialState: initialProductState,
  reducers: {
    setProductList: (state, action: PayloadAction<Product[]>) => {
      state.productList = action.payload;
    },
    resetProductList: (state) => {
      state.productList = initialProductState.productList;
    },
    addProductList: (state, action: PayloadAction<Product[]>) => {
      state.productList = [...state.productList, ...action.payload];
    },
    setProductDetail: (state, action: PayloadAction<Product>) => {
      state.productDetail = action.payload;
    },
    resetProductDetail: (state) => {
      state.productDetail = initialProductState.productDetail;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setProductList,
  resetProductList,
  addProductList,
  setProductDetail,
  resetProductDetail,
} = productSlice.actions;

export default productSlice.reducer;
